import React, {useEffect, useState} from 'react';

import ShapeStyling from "../../shapes/ShapeStyling";

import {useParams} from "react-router-dom";
import {Tooltip} from "react-tooltip";
import {useAuth} from "../../../../providers/AuthProvider";
import {IconCapStraight, IconShape2} from "@tabler/icons-react";


export default function ShapesControl({ project, locations, shapes, onAddShapeClick, onAddMarkClick, onRulerActive, canEdit = false}) {
    const {projectId} = useParams();
    const {user} = useAuth();

    const [rulerActive, setRulerActive] = useState(false);
    const [btnActive, setBtnActive] = useState('');
    const [projectStatus, setProjectStatus] = useState(project.status ? project.status : '30_cancelled');
    const [drawAreaActive, setDrawAreaActive] = useState(false);
    const [drawMarkActive, setDrawMarkActive] = useState(false);


    useEffect(() => {
        if (project.status) {
            setProjectStatus(project.status);
        }
    }, [project.status]);


    useEffect(() => {
        let shapesActive = true;
        if (shapes && Object.keys(shapes).length) {
            Object.values(shapes).forEach((shape) => {
                if (!shape.active) {
                    shapesActive = false;
                }
            });
        }

        if (!shapesActive && btnActive) {
            setBtnActive('');
        }
    }, [shapes]);


    const onRulerClick = (e) => {
        e.preventDefault();
        if (!canEdit) {return false;}

        setRulerActive(!rulerActive);

        onRulerActive(rulerActive);
    }


    const onAddClick = (e, type, isMark = false) => {
        e.preventDefault();
        if (!canEdit) {return false;}

        if (btnActive === 'new-shape-' + type) {
            setBtnActive('');
            if (isMark) {
                onAddMarkClick(null);
            } else {
                onAddShapeClick(null);
            }
        } else {
            setBtnActive('new-shape-' + type);
            if (isMark) {
                onAddMarkClick(type);
            } else {
                onAddShapeClick(type, isMark);
            }
        }
    }


    const onDownloadCatids = (e) => {
        e.preventDefault();
        if (!canEdit) {return false;}

        let catids = [];
        Object.keys(locations.byShape).forEach((key) => {
            locations.byShape[key].positive.forEach((location) => {
                if (!catids.length) {
                    //let headers = ['ProjectId'].concat(Object.keys(location));
                    const headers = ['Project_ID', 'User_ID', 'Building_location_ID', 'Filter', 'Version', 'Requested'];
                    catids.push(headers);
                }

                // format as YYYY-MM-DD HH:MM:SS
                let currentDateUTC = new Date().toISOString().slice(0, 19).replace('T', ' ');
                let row = [projectId, user.id, location.building_location_id, location.filter, location.version, currentDateUTC];
                catids.push(row);
            });
        });

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += catids.map(e => e.join(",")).join("\n");

        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "catids-"+projectId+".csv");
        document.body.appendChild(link); // Required for FF

        link.click();

        document.body.removeChild(link);
    }


    const toggleDrawArea = (e) => {
        if (!canEdit) {return false;}

        e.preventDefault();

        if (!drawAreaActive) {
            setDrawAreaActive(true);
            setDrawMarkActive(false);
        } else {
            setDrawAreaActive(false);
            setDrawMarkActive(false);
        }
    }

    const toggleDrawMark = (e) => {
        if (!canEdit) {return false;}
        e.preventDefault();

        if (!drawMarkActive) {
            setDrawMarkActive(true);
            setDrawAreaActive(false);
        } else {
            setDrawMarkActive(false);
            setDrawAreaActive(false);
        }
    }



    return (
        <>
            <div className={'btn-group-vertical'+((projectStatus !== '00_in_progress' || !canEdit) ? ' d-none' : '')}>
                <button
                    onClick={toggleDrawArea}
                    className={'btn btn-onmap btn-group-inner-single'}

                    data-tooltip-html="<div style='margin-bottom: 5px;'>Add a selection shape.</div><div>Properties within your shape will be selected.</div>"
                    data-tooltip-place="right"
                    data-tooltip-id="shapes-control-tooltip"
                    data-tooltip-hidden={drawAreaActive}
                >
                    <i className={'ti ti-hexagon-plus-2 fs-5'}></i>
                </button>

                <div className={'btn-group btn-group-inner' + (drawAreaActive ? '' : ' d-none')}>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_POLYGON)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_POLYGON ? ' active' : '')}

                        data-tooltip-content="Draw a polygon"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-polygon fs-5'}></i>
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_BUFFER)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_BUFFER ? ' active' : '')}

                        data-tooltip-content="Draw a Buffer"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <IconCapStraight size={20} stroke={2} />
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_RECTANGLE)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_RECTANGLE ? ' active' : '')}

                        data-tooltip-content="Draw a rectangle"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-rectangle fs-5'}></i>
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_CIRCLE)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_CIRCLE ? ' active' : '')}

                        data-tooltip-content="Draw a radius"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-circle-dot fs-5'}></i>
                    </button>
                </div>
            </div>

            <div className={'btn-group-vertical'+((projectStatus !== '00_in_progress' || !canEdit) ? ' d-none' : '')}>
                <button
                    onClick={toggleDrawMark}
                    className={'btn btn-onmap btn-group-inner-single'}

                    data-tooltip-html="<div style='margin-bottom: 5px;'>Add a reference shape.</div><div>Properties within your shape will not be selected.</div>"
                    data-tooltip-place="right"
                    data-tooltip-id="shapes-control-tooltip"
                    data-tooltip-delay="1000"
                    data-tooltip-hidden={drawMarkActive}
                >
                    <i className={'ti ti-map-pin-plus fs-5'}></i>
                </button>

                <div className={'btn-group btn-group-inner' + (drawMarkActive ? '' : ' d-none')}>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_POLYGON, true)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_POLYGON ? ' active' : '')}

                        data-tooltip-content="Add a polygon reference"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-lasso-polygon fs-5'}></i>
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_BUFFER, true)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_BUFFER ? ' active' : '')}

                        data-tooltip-content="Add a polyline reference"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <IconShape2 size={20} stroke={2} />
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_RECTANGLE, true)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_RECTANGLE ? ' active' : '')}

                        data-tooltip-content="Add a rectangle reference"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-transform-point fs-5'}></i>
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_CIRCLE, true)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_CIRCLE ? ' active' : '')}

                        data-tooltip-content="Add a radius reference"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-circle-dashed fs-5'}></i>
                    </button>
                    <button
                        onClick={(e) => onAddClick(e, ShapeStyling.TYPE_POINT, true)}
                        className={'btn btn-onmap' + (btnActive === 'new-shape-' + ShapeStyling.TYPE_POINT ? ' active' : '')}

                        data-tooltip-content="Add a point reference"
                        data-tooltip-place="top"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-map-pin fs-5'}></i>
                    </button>
                </div>
            </div>

            <div className="btn-group-vertical">
                <button
                    onClick={onRulerClick}
                    className={'btn btn-onmap'}

                    data-tooltip-content="Measure distance"
                    data-tooltip-place="right"
                    data-tooltip-id="shapes-control-tooltip"
                >
                    <i className={'ti ti-ruler fs-5'}></i>
                </button>
            </div>

            {/*shapes && Object.keys(shapes).length ? (
                <div className={'btn-group-vertical'+((projectStatus !== '00_in_progress' || !canEdit) ? ' d-none' : '')}>
                    <button
                        onClick={onRefreshClick}
                        className={'btn btn-onmap'}

                        data-tooltip-content="Generate Counts"
                        data-tooltip-place="right"
                        data-tooltip-id="shapes-control-tooltip"
                    >
                        <i className={'ti ti-refresh-dot fs-5'}></i>
                    </button>
                </div>
            ) : ''*/}

            <div className={'btn-group-vertical'+(user.type !== 'admin' ? ' d-none' : '')}>
                <button
                    onClick={onDownloadCatids}
                    className={'btn btn-onmap'}

                    data-tooltip-content="Export Data"
                    data-tooltip-place="right"
                    data-tooltip-id="shapes-control-tooltip"
                >
                    <i className={'ti ti-table-down fs-5'}></i>
                </button>
            </div>

            <Tooltip id="shapes-control-tooltip" />
        </>
    );
}